import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ModernColorSpaces from './ModernColorSpaces';
import ClientProvider from './client';
export default createDemo(import.meta.url, ModernColorSpaces, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/css-theme-variables/demos/modern-color-spaces/ModernColorSpaces.tsx",
    "fileName": "ModernColorSpaces.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport Radio from '@mui/material/Radio';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport FormLabel from '@mui/material/FormLabel';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormControl from '@mui/material/FormControl';\n\nexport default function ModernColorSpaces() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const colorSpaces = [\n    'color(display-p3 0.7 0.5 0)', // Mud\n    'oklch(0.62 0.25 29)', // Orange\n    'oklab(0.59 0.1 -0.14)', // Purple\n    'hsl(141, 70%, 48%)', // Green\n    'rgb(25, 118, 210)', // Blue\n  ];\n\n  const [selectedColor, setSelectedColor] = React.useState(colorSpaces[0]);\n\n  const theme = React.useMemo(\n    () =>\n      createTheme({\n        cssVariables: {\n          nativeColor: true,\n          cssVarPrefix: 'modern-color-spaces',\n        },\n        palette: {\n          primary: {\n            main: selectedColor,\n          },\n        },\n      }),\n    [selectedColor],\n  );\n\n  return (\n    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>\n      <FormControl>\n        <FormLabel>Main color</FormLabel>\n        <RadioGroup\n          value={selectedColor}\n          onChange={(event) => setSelectedColor(event.target.value)}\n        >\n          {colorSpaces.map((value) => (\n            <FormControlLabel\n              key={value}\n              value={value}\n              control={<Radio />}\n              label={value}\n            />\n          ))}\n        </RadioGroup>\n      </FormControl>\n\n      <ThemeProvider theme={theme}>\n        <Button variant=\"contained\" size=\"large\">\n          Button\n        </Button>\n      </ThemeProvider>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 64,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport Radio from '@mui/material/Radio';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport FormLabel from '@mui/material/FormLabel';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormControl from '@mui/material/FormControl';\n\nexport default function ModernColorSpaces() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const colorSpaces = [\n    'color(display-p3 0.7 0.5 0)', // Mud\n    'oklch(0.62 0.25 29)', // Orange\n    'oklab(0.59 0.1 -0.14)', // Purple\n    'hsl(141, 70%, 48%)', // Green\n    'rgb(25, 118, 210)', // Blue\n  ];\n\n  const [selectedColor, setSelectedColor] = React.useState(colorSpaces[0]);\n\n  const theme = React.useMemo(\n    () =>\n      createTheme({\n        cssVariables: {\n          nativeColor: true,\n          cssVarPrefix: 'modern-color-spaces',\n        },\n        palette: {\n          primary: {\n            main: selectedColor,\n          },\n        },\n      }),\n    [selectedColor],\n  );\n\n  return (\n    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>\n      <FormControl>\n        <FormLabel>Main color</FormLabel>\n        <RadioGroup\n          value={selectedColor}\n          onChange={(event) => setSelectedColor(event.target.value)}\n        >\n          {colorSpaces.map((value) => (\n            <FormControlLabel\n              key={value}\n              value={value}\n              control={<Radio />}\n              label={value}\n            />\n          ))}\n        </RadioGroup>\n      </FormControl>\n\n      <ThemeProvider theme={theme}>\n        <Button variant=\"contained\" size=\"large\">\n          Button\n        </Button>\n      </ThemeProvider>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 64,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Button",
      "@mui/material/Radio",
      "@mui/material/RadioGroup",
      "@mui/material/FormLabel",
      "@mui/material/FormControlLabel",
      "@mui/material/FormControl"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
